import { BOOKING_SETTINGS, BookingSettingsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

export function SettingsOnlineBookingPage() {
  const navigate = useNavigate();
  return (
    <BookingSettingsView
      data={BOOKING_SETTINGS}
      onOpenGeneralInfo={() => { void navigate('/settings/general'); }}
      onOpenReasons={() => { void navigate('/settings/appointment-reasons'); }}
      onOpenCancellation={() => { void navigate('/settings/cancellation-policy'); }}
    />
  );
}
